import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMVariantButton, MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import ValidatableAttachmentFiles from '../../ui-parts/ValidatableAttachmentFiles';
import ValidatableDropDownList from '../../ui-parts/ValidatableDropDownList';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';


/** MyMine Version1.5 Support画面新規追加
* Support Page Content
*/
const Support = () => {
  // 変数・State
  const screenId = 'MyM701';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList } = useWebContext(screenId);
  const [enquiryReasonList, setEnquiryReasonList] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [isSubmited, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { handleSubmit, control, formState, clearErrors, trigger, setValue } = useForm({
    mode: 'onSubmit',
  })
  const [files, setFiles] = useState([]);
  const [selectEnquiryReason, setSelectEnquiryReason] = useState(null);
  const [selectEnquiryReasonSub, setSelectEnquiryReasonSub] = useState(null);
  const validationRules = useValidationRules();
  const isPc = useMediaQuery(mediaQuery.pc);
  useEffect(() => {
  }, []);
  // 2025.7.7 MyMine Version3.0対応 Add Start

  // スタイル
  const theme = useTheme();

  const myMSupportButtonStyle =
  {
    border: '2px solid #777777',
    borderRadius: '10px',
    fontSize: '1rem',
    color: '#000000',
    margin: '10px',
    width: '190px',
    backgroundColor: ' #fff',
    ':hover': {
      backgroundColor: ' #fff',
    }
  };

  const onClickBtnSubmit = (data, e) => {
    if (window.confirm(messageList.MyM_MSG_I_0052)) {
      const formData = new FormData();
      formData.append(`Name`, data.name);
      formData.append(`Email`, data.userId);
      formData.append(`Detail`, data.detail);
      formData.append(`ReasonId`, selectEnquiryReason);
      formData.append(`ReasonSubId`, selectEnquiryReasonSub);
      files.forEach((file, i) => { formData.append(`AttachmentFile`, file); })

      const callbackSuccess = (result) => {
        setIsLoading(false);
        setIsSubmitted(true);
      }

      const callbackFailed = () => setIsLoading(false);

      //POST
      apiRequest.requestForm('api/enquiry/submit', 'POST', callbackSuccess, callbackFailed, formData);

      setIsLoading(true);
    }
  }

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  // ページロード時処理
  useEffect(() => {
    const callbackPageLoadContext = (result) => {
      setEnquiryReasonList(result.EnquiryReasonList);
      setUserInfo(result.UserInfo);
      setIsLoading(false);
    }

    const callbackFailed = () => setIsLoading(false);

    apiRequest.requestJson('api/enquiry/load', 'GET', callbackPageLoadContext, callbackFailed)
    setIsLoading(true);
  }, []);

  if (userInfo.length === 0)
    return <MyMProgress />

  return (
    <Box className='py-1'>
      {isLoading && <MyMProgress />}
      <Box >
        <MyMVariantLabel variant='h5' sx={{ fontSize: '28px' }}>{controlSettings.LabelList.lblSupportTitle}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblSupportDescription}</MyMLabel>
        <Box sx={{ height: {lg: '25px' } }} />
      </Box>
      {isPc ? 
        <Grid container className='d-flex align-items-center justify-content-start' sx={{ paddingTop: '5px' }}>
          <Box
            className='d-flex'
            sx={{
              flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
              width: '100%',
              gap: 2,
            }}
          >
            <Box
              className='d-flex'
              sx={{
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Box sx={{ padding: '5px 5px' }}>
                <MyMVariantLabel variant='h5' sx={{ fontSize: '16px' }}>
                  {controlSettings.LabelList.lblFaqMessage}
                </MyMVariantLabel>
              </Box>
              <Box sx={{ padding: '5px 5px' }}>
                <MyMVariantLabel variant='h5' sx={{ fontSize: '16px' }}>
                  {controlSettings.LabelList.lblSupportMessage}
                </MyMVariantLabel>
              </Box>
            </Box>

            {/* 右側：ボタン */}
            <Box className='d-flex align-items-center justify-content-center' sx={{ padding: '10px 20px' }}>
              <MyMButton
                fontSize='20px'
                onClick={() => navigate('/MyM102/MyM708')}
                sx={{
                  width: '220px',
                  maxWidth: '100%',
                }}
              >
                {controlSettings.LabelList.btnFaq}
              </MyMButton>
            </Box>
          </Box>
        </Grid>
        :
        <>
          <Box className='d-flex align-items-center justify-content-center' sx={{ padding: '20px 0' }}>
            <MyMVariantLabel variant='h5' sx={{ fontSize: '16px' }}>
              {controlSettings.LabelList.lblFaqMessage}
            </MyMVariantLabel>
          </Box>
          <Box className='d-flex align-items-center justify-content-center' sx={{ padding: '10px 0' }}>
            <MyMVariantLabel variant='h5' sx={{ fontSize: '16px' }}>
              {controlSettings.LabelList.lblSupportMessage}
            </MyMVariantLabel>
          </Box>
          <Box className='d-flex align-items-center justify-content-center' sx={{ padding: '10px 0' }}>
            <MyMButton
              fontSize='20px'
              onClick={() => navigate('/MyM102/MyM708')}
              sx={{
                width: '220px',
                maxWidth: '100%',
              }}
            >
              {controlSettings.LabelList.btnFaq}
            </MyMButton>
          </Box>
        </>
      }
      <Grid container>
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={isPc ? 10 : 12} sx={{ margin: '20px 0' }}>

          <OutlinedCustomCard>
            <CardHeader
              sx={{ display: 'flex', background: theme.palette.background.secondary, height: '10%' }}
              titleTypographyProps={{ align: 'center' }}
              title={<MyMLabel fontSize='1.5rem' sx={{ color: 'white' }}>{controlSettings.LabelList.lblSupportEnquiryForm}</MyMLabel>}
            />
            {isSubmited === false ?
              <CardContent sx={{ backgroundColor: 'rgba(5, 5, 10, 0.04)' }}>
                <Grid container>
                  <Grid item xs={isPc ? 5.5 : 12} sx={{ paddingBottom: !isPc && '17px' }}>
                    <ValidatableTextBox
                      control={control}
                      name="name"
                      defaultValue={`${userInfo?.FirstName ?? ''} ${userInfo?.LastName ?? ''}`.trim()}
                      formState={formState}
                      maxLength={100}
                      rules={
                        {
                          ...validationRules.required(),
                          ...validationRules.maxLength(100),
                        }
                      }
                      InputProps={{ startAdornment: <InputAdornment position="start">{controlSettings.LabelList.lblName}</InputAdornment> }}
                      style={{ background: 'white' }}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={isPc ? 5.5 : 12}>
                    <ValidatableTextBox
                      control={control}
                      name="userId"
                      defaultValue={userInfo.UserId}
                      formState={formState}
                      maxLength={256}
                      rules={
                        {
                          ...validationRules.required(),
                          ...validationRules.maxLength(256),
                          ...validationRules.mailAddress(),
                        }
                      }
                      InputProps={{ startAdornment: <InputAdornment position="start">{controlSettings.LabelList.lblEmail}</InputAdornment> }}
                      style={{ background: 'white' }}
                    />
                  </Grid>

                  <Grid item xs={12} className='mt-3'>
                    <ValidatableDropDownList
                      maxWidth
                      control={control}
                      formState={formState}
                      needsBlank={true}
                      onChange={e => {
                        setValue('selectEnquiryReasonSub', "");
                        setSelectEnquiryReason(e.target.value)
                      }}
                      name="enquiryReason"
                      placeholder={controlSettings.LabelList.lblReasonForEnquiry}
                      value={selectEnquiryReason ?? ''}
                      options={enquiryReasonList.filter(x => x.ParentId === null).map((list) => {
                        return {
                          value: list.Id,
                          text: list.Name,
                        }
                      })}
                      rules={{ ...validationRules.required(), }}
                      style={{ background: 'white' }}
                    />
                  </Grid>

                  <Grid item xs={12} className={`mt-3 ${!selectEnquiryReason && 'd-none'}`}>
                    <ValidatableDropDownList
                      maxWidth
                      control={control}
                      formState={formState}
                      needsBlank={true}
                      onChange={e => setSelectEnquiryReasonSub(e.target.value)}
                      name="selectEnquiryReasonSub"
                      placeholder={controlSettings.LabelList.lblReasonForEnquirySub}
                      value={selectEnquiryReasonSub ?? ''}
                      options={enquiryReasonList.filter(x => x.ParentId === selectEnquiryReason).map((list) => {
                        return {
                          value: list.Id,
                          text: list.Name,
                        }
                      })}
                      rules={{ ...validationRules.required(), }}
                      style={{ background: 'white' }}
                    />
                  </Grid>

                  <Grid item xs={12} className='mt-3'>
                    <ValidatableTextBox
                      multiline
                      rows={16}
                      height='100%'
                      control={control}
                      name="detail"
                      maxLength={2000}
                      formState={formState}
                      rules={
                        {
                          ...validationRules.required(),
                          ...validationRules.maxLength(2000),
                        }
                      }
                      placeholder={controlSettings.LabelList.lblDetail}
                      style={{ background: 'white' }}
                    />
                  </Grid>

                  <Grid item xs={12} className='mt-3'>
                    {/* 2024.9.16 MyMine Version2.0対応 Modify Start */}
                    <ValidatableAttachmentFiles
                      controlSettings={controlSettings}
                      messageList={messageList}
                      control={control}
                      files={files}
                      setFiles={setFiles}
                      clearErrors={clearErrors}
                      formState={formState}
                      trigger={trigger}
                      fileSizeValidMessageKey='MyM_MSG_E_0013'
                    />
                    {/* 2024.9.16 MyMine Version2.0対応 Modify End */}
                  </Grid>
                  <Grid item xs={12} className='mt-3'>
                    <Stack direction='row' justifyContent="flex-end" spacing={3} className='me-3' sx={{ padding: '0 0 10px 0' }}>
                      <MyMVariantButton
                        sx={myMSupportButtonStyle}
                        fullWidth
                        onClick={handleSubmit(onClickBtnSubmit, onError)}
                        variant='contained'>{controlSettings.LabelList.btnSubmit}</MyMVariantButton>
                      <MyMVariantButton sx={myMSupportButtonStyle} variant='contained' onClick={() => navigate(-1)}>{controlSettings.LabelList.btnBack}</MyMVariantButton>
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
              :
              <CardContent>
                <Box className='text-center'>
                  <MyMLabel>{controlSettings.LabelList.lblMessage}</MyMLabel>
                  <MyMVariantButton sx={myMSupportButtonStyle} variant='contained' onClick={() => navigate(-1)}>{controlSettings.LabelList.btnBack}</MyMVariantButton>
                </Box>
              </CardContent>
            }
          </OutlinedCustomCard>
        </Grid>
        <Grid item xs={1}>
        </Grid>
      </Grid>
    </Box>
  );
}
export default Support;